import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b8csz3xa8h: FaireBrandEntity = {
  token: "b_b8csz3xa8h",
  type: "brand",
  name: "Gypsy Soul",
  avatarUrl:
    "https://cdn.faire.com/fastly/e1ca3833852051df23fed5fb93d0b7ffb798b2bd5cc717e22101fcf0dd7b04a0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3490adbbaa5b5710850f743e667e21d474bc42962844a75ed11469af4579f872.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e1ca3833852051df23fed5fb93d0b7ffb798b2bd5cc717e22101fcf0dd7b04a0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3490adbbaa5b5710850f743e667e21d474bc42962844a75ed11469af4579f872.png",
  location: "Myrtle Beach, SC, USA",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 271,
  isTopShop: true,
  isInsider: true,
  description:
    "We serve everybody who is wanderers, adventurists, spiritualists, and bohemian-spirited individuals. We thrive to be environment-friendly and bring the most quality with unique finds. Our mission is to provide unique finds of handcrafted beauty and home decor items. These are not limited to lotion candles, mosaic lamps, metaphysical supplies, genuine gemstones, and gemstone jewelry as well as fair trade items.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:29.123Z",
    importedBy: "entity-db-cli",
  },
};
